/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';
import packageJson from '../../../package.json';
import { Capacitor } from '@capacitor/core';

const RealeaseName = packageJson.version + '+' + packageJson.build;

if (process.env.REACT_APP_SENTRY_ENV === 'production') {
  Sentry.init(
    {
      dsn: `${process.env.REACT_APP_SENTRY_URL}`,
      release: RealeaseName,
      environment: process.env.REACT_APP_SENTRY_ENV,
      integrations: [
        ...SentryReact.getDefaultIntegrations({}),
        SentryReact.breadcrumbsIntegration({
          console: true,
          dom: false,
          fetch: true,
          history: true,
          xhr: true,
        }),
        SentryReact.browserTracingIntegration(),
        SentryReact.replayIntegration({
          blockAllMedia: false,
          maskAllText: false,
          networkCaptureBodies: true,
          networkDetailAllowUrls: ['*.azure-api.net', '*.typesense.net'],
        }),
      ],
      denyUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        'https://images-ap-prod.cms.commerce.dynamics.com',
        'https://analytics.google.com',
      ],
      beforeSend: async (event) => {
        if (window.location.hostname === 'localhost' || Capacitor.DEBUG) {
          return null;
        }
        return event;
      },
      transport: SentryReact.makeBrowserOfflineTransport(SentryReact.makeFetchTransport),
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    },
    // Forward the init method from @sentry/react
    SentryReact.init,
  );

  Sentry.setTag('cap_platform', Capacitor.getPlatform());
  Sentry.setTag('cap_env', process.env.REACT_APP_SENTRY_ENV);
}
